"use client";

import { c as _c } from "react/compiler-runtime";
import { CustomLink } from "@repo/design-system/components/ui/custom-link";
import { combineEmploymentTypes, getCanonicalUrl } from "@repo/design-system/utils/helpers";
import { QRCodeSVG } from "qrcode.react";
import { useLanguage } from "~/translations/loader/use-language";
import type { Job } from "~/types/job";
export function PrintviewDetailsBoxEonUk(t0) {
  const $ = _c(69);
  const {
    job
  } = t0;
  const t = useLanguage();
  let t1;
  if ($[0] !== job) {
    t1 = getCanonicalUrl(job);
    $[0] = job;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const canonicalUrl = t1;
  const qrCodeUrl = `${canonicalUrl}?utm_source=PrintedJobad&utm_medium=Print&utm_campaign=QRCodePrint&utm_id=QRCodePrint&utm_term=QRCodePrint&utm_content=QRCodePrint`;
  let t2;
  if ($[2] !== t.jobad_detailsPrint_HL) {
    t2 = <h2 className="mb-3 font-bold text-primary">{t.jobad_detailsPrint_HL}</h2>;
    $[2] = t.jobad_detailsPrint_HL;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t.jobad_details_employmentType) {
    t3 = <p className="mb-1 font-bold">{t.jobad_details_employmentType}</p>;
    $[4] = t.jobad_details_employmentType;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== job.data.employmentType || $[7] !== t) {
    t4 = combineEmploymentTypes(job.data.employmentType, t);
    $[6] = job.data.employmentType;
    $[7] = t;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t4) {
    t5 = <p>{t4}</p>;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t3 || $[12] !== t5) {
    t6 = <div>{t3}{t5}</div>;
    $[11] = t3;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t.jobad_details_contractType) {
    t7 = <p className="mb-1 font-bold">{t.jobad_details_contractType}</p>;
    $[14] = t.jobad_details_contractType;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== job.data.contract) {
    t8 = <p>{job.data.contract}</p>;
    $[16] = job.data.contract;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== t7 || $[19] !== t8) {
    t9 = <div>{t7}{t8}</div>;
    $[18] = t7;
    $[19] = t8;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== t.jobad_details_remote) {
    t10 = <p className="mb-1 font-bold">{t.jobad_details_remote}</p>;
    $[21] = t.jobad_details_remote;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] !== job.data.remote) {
    t11 = <p>{job.data.remote}</p>;
    $[23] = job.data.remote;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  let t12;
  if ($[25] !== t10 || $[26] !== t11) {
    t12 = <div>{t10}{t11}</div>;
    $[25] = t10;
    $[26] = t11;
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  let t13;
  if ($[28] !== t.jobad_details_company) {
    t13 = <p className="mb-1 font-bold">{t.jobad_details_company}</p>;
    $[28] = t.jobad_details_company;
    $[29] = t13;
  } else {
    t13 = $[29];
  }
  let t14;
  if ($[30] !== job.data.company) {
    t14 = <p>{job.data.company}</p>;
    $[30] = job.data.company;
    $[31] = t14;
  } else {
    t14 = $[31];
  }
  let t15;
  if ($[32] !== t13 || $[33] !== t14) {
    t15 = <div>{t13}{t14}</div>;
    $[32] = t13;
    $[33] = t14;
    $[34] = t15;
  } else {
    t15 = $[34];
  }
  let t16;
  if ($[35] !== t.jobad_details_jobNumber) {
    t16 = <p className="mb-1 font-bold">{t.jobad_details_jobNumber}</p>;
    $[35] = t.jobad_details_jobNumber;
    $[36] = t16;
  } else {
    t16 = $[36];
  }
  let t17;
  if ($[37] !== job.data.jobNumber) {
    t17 = <p>{job.data.jobNumber}</p>;
    $[37] = job.data.jobNumber;
    $[38] = t17;
  } else {
    t17 = $[38];
  }
  let t18;
  if ($[39] !== t16 || $[40] !== t17) {
    t18 = <div>{t16}{t17}</div>;
    $[39] = t16;
    $[40] = t17;
    $[41] = t18;
  } else {
    t18 = $[41];
  }
  let t19;
  if ($[42] !== job.data.recruiterData || $[43] !== t.footer_contact) {
    t19 = job.data.recruiterData?.recruiter_mail && <div><p className="mb-1 font-bold">{t.footer_contact}</p><p>{job.data.recruiterData.recruiter_mail}</p></div>;
    $[42] = job.data.recruiterData;
    $[43] = t.footer_contact;
    $[44] = t19;
  } else {
    t19 = $[44];
  }
  let t20;
  if ($[45] !== t12 || $[46] !== t15 || $[47] !== t18 || $[48] !== t19 || $[49] !== t6 || $[50] !== t9) {
    t20 = <div className="mb-4 space-y-2 text-xs">{t6}{t9}{t12}{t15}{t18}{t19}</div>;
    $[45] = t12;
    $[46] = t15;
    $[47] = t18;
    $[48] = t19;
    $[49] = t6;
    $[50] = t9;
    $[51] = t20;
  } else {
    t20 = $[51];
  }
  let t21;
  if ($[52] !== t.jobad_inclusionHL) {
    t21 = <p className="mb-2 font-bold text-sm">{t.jobad_inclusionHL}</p>;
    $[52] = t.jobad_inclusionHL;
    $[53] = t21;
  } else {
    t21 = $[53];
  }
  let t22;
  if ($[54] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = <p>At E.ON, we're committed to building a diverse, inclusive, and respectful workplace where everyone can thrive. However you identify, and whatever your background, we welcome your application. We value the unique perspectives that each individual brings - because a sustainable future needs all of us. We aim to make our recruitment process accessible to all. Visit our{" "}<CustomLink blank={true} className="font-medium text-primary underline" href="https://www.eon-uk-careers.com/en/job-search/application-support.html">Application Support</CustomLink>{" "}page if you need adjustments or support.</p>;
    $[54] = t22;
  } else {
    t22 = $[54];
  }
  let t23;
  if ($[55] !== t21) {
    t23 = <div className="mb-4 py-2 text-xs">{t21}{t22}</div>;
    $[55] = t21;
    $[56] = t23;
  } else {
    t23 = $[56];
  }
  let t24;
  if ($[57] !== t.jobad_qrcode_HL) {
    t24 = <p className="mb-2 font-bold text-sm">{t.jobad_qrcode_HL}</p>;
    $[57] = t.jobad_qrcode_HL;
    $[58] = t24;
  } else {
    t24 = $[58];
  }
  let t25;
  if ($[59] !== qrCodeUrl) {
    t25 = <div className="py-1" suppressHydrationWarning={true}><QRCodeSVG size={80} value={qrCodeUrl} /></div>;
    $[59] = qrCodeUrl;
    $[60] = t25;
  } else {
    t25 = $[60];
  }
  let t26;
  if ($[61] !== t24 || $[62] !== t25) {
    t26 = <div className="break-inside-avoid">{t24}{t25}</div>;
    $[61] = t24;
    $[62] = t25;
    $[63] = t26;
  } else {
    t26 = $[63];
  }
  let t27;
  if ($[64] !== t2 || $[65] !== t20 || $[66] !== t23 || $[67] !== t26) {
    t27 = <div className="col-span-2 h-min p-4 pr-2">{t2}{t20}{t23}{t26}</div>;
    $[64] = t2;
    $[65] = t20;
    $[66] = t23;
    $[67] = t26;
    $[68] = t27;
  } else {
    t27 = $[68];
  }
  return t27;
}